import * as React from "react";
import { observer, inject } from "mobx-react";
// import { toJS } from "mobx";

import { Link } from "react-router-dom";
import { HorseForSaleStore } from "src/stores/HorseForSaleStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { CheckoutActiveStates } from "src/model/HorseForSale";

export interface Props {
    horseForSaleStore?: HorseForSaleStore;
}

export interface State {}

@inject("horseForSaleStore")
@observer
export default class Checkout extends React.Component<Props, State> {
    render() {
        const { horseForSaleStore } = this.props;
        if (!horseForSaleStore) {
            throw new Error(" ** No Horse For Sale Store **");
        }

        const horseForSale = horseForSaleStore.horseForSale;
        if (!horseForSale) {
            return <div />;
        }

        const disableCheckoutButton = CheckoutActiveStates(horseForSale.state);

        return (
            <>
                <div className="card shadow">
                    <div className="card-header">
                        Checkout {horseForSale.hipNumber ? "# " + horseForSale.hipNumber : ""} {horseForSale.horse.name}
                    </div>
                    <div className="card-body">
                        <div className="form-row">
                            <div className="col-12">
                                <div className="alert alert-info text-center" role="alert">
                                    This page allows you to view, edit or start the checkout of a horse for sale.
                                    <br />
                                    Just click the button below and the checkout page will open.
                                    <br />
                                    To checkout the horse for the first time, the <i>
                                        Acknowledgement of Purchase and Acceptance of Conditions form
                                    </i>{" "}
                                    has to be entered first.
                                    <br />
                                    Note that changes to the checkout details of a horse already sold may affect invoices and buyers and sellers'
                                    accounts.
                                </div>
                            </div>
                        </div>
                        <div className="form-row my-5">
                            <div className="col-12 text-center">
                                <Link
                                    className={`btn btn-primary ${!disableCheckoutButton ? `disabled` : ``}`}
                                    to={
                                        disableCheckoutButton
                                            ? {
                                                  pathname: `/checkout/${horseForSale.id}/buyers`
                                              }
                                            : {}
                                    }
                                >
                                    <FontAwesomeIcon icon={faShoppingCart} className="mr-2" />
                                    Open Checkout for {horseForSale.hipNumber ? "#" + horseForSale.hipNumber : ""} {horseForSale.horse.name}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses-for-sale/Checkout.tsx